export interface CustomerRemarkRule {
  id?: number;
  type: CustomerRemarkRuleType;
  link?: CustomerRemarkRuleLink;
  keyword?: CustomerRemarkRuleKeyword;
  permanent: boolean;
  period?: CustomerRemarkRulePeriod;
  remark: string;
  gmtCreate?: string;
  gmtModified?: string;
}

export interface CustomerRemarkRuleLink {
  title: string;
  oriLink: string;
}

export interface CustomerRemarkRuleKeyword {
  keyword: string;
  fullMatch: boolean;
}

export interface CustomerRemarkRulePeriod {
  startNow: boolean;
  startAt?: string;
  endAt: string;
}

export enum CustomerRemarkRuleType {
  Link = 0,
  Keyword = 1,
  Other = -1,
}

export default {
  id: undefined,
  type: CustomerRemarkRuleType.Link,
  link: {},
  permanent: true,
  period: undefined,
  gmtCreate: undefined,
  gmtModified: undefined,
} as CustomerRemarkRule;
